import React, { useState, useEffect } from 'react';
import { Grid, Box, Button, useTheme, Alert, AlertTitle, Snackbar, Slide } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import backgroundImage from '../assets/image/bg2.png'
import ornament from '../assets/image/ornamen.png'
import bg1 from '../assets/image/bgamplop1.png'
import bg2 from '../assets/image/bgamplop2.png'
import ornament1 from '../assets/image/amplop1.png'
import ornament2 from '../assets/image/amplop2.png'

const AmplopDigital = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('success')
    const [title, setTitle] = useState('')
    const [message, setMessage] = useState('')

    const bank1 = 'Mandiri'
    const rekening1 = '1350015886680'
    const atasNama1 = 'Lilik Waloyo'

    const bank2 = 'Mandiri'
    const rekening2 = '1780002200240'
    const atasNama2 = 'Yuyun Laylia El Mahera'

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const theme = useTheme();

    const handleButtonClick = (rekening) => {
        if (!navigator.clipboard) {
            // Clipboard API not available
            // alert("something went wrong1");
            setSeverity('error')
            setTitle('Yahh..') 
            setMessage('terjadi kesalahan saat menyalin')
            setOpen(true);
            return;
        }
        navigator.clipboard.writeText(rekening).then(() => {
            // alert("successfully copied");
            setSeverity('success')
            setTitle('Berhasil') 
            setMessage('nomor rekening berhasil disalin!')
            setOpen(true);
        }).catch(() => {
            setSeverity('error')
            setTitle('Yahh..') 
            setMessage('nomor rekening gagal disalin')
            setOpen(true);
            // alert("something went wrong");
        });
    }

    const styles ={
        box: {
            display: 'grid', 
            flexDirection: 'column', 
            alignItems: 'center', 
            color: 'dark.main',
            padding: windowWidth > 600 ? '5% 17% 10% 17%' : '5% 17% 10% 17%',
            // backgroundColor: theme.palette.light.main,
            // backgroundImage: `url(${backgroundImage})`,
            // backgroundRepeat: 'no-repeat',
            // backgroundPosition: 'left center',
            // backgroundSize: 'contain',
            overflow: 'hidden' 
        },
        bg1: {
            left: 0,
            zIndex: 0,
            position: 'absolute',
            marginTop: '-20vh',
            width: `${65+windowWidth*0.02}%`,
            height: `${60+windowWidth*0.02}vh`,
            backgroundImage: `url(${bg1})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'left',
        },
        bg2: {
            right: 0,
            zIndex: 0,
            position: 'absolute',
            marginTop: '30vh',
            width: `${70+windowWidth*0.012}%`,
            height: `${75+windowWidth*0.012}vh`,
            backgroundImage: `url(${bg2})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'right',
        },
        ornament1: {
            left: 0,
            display: 'flex',
            zIndex: 0,
            position: 'absolute',
            marginTop: '70vh',
            width: `${45+windowWidth*0.025}%`,
            height: `${25+windowWidth*0.01}vh`,
            backgroundImage: `url(${ornament1})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'left',
          },
        ornament2: {
            right: 0,
            display: 'flex',
            zIndex: 0,
            position: 'absolute',
            marginTop: '75vh',
            width: `${40+windowWidth*0.025}%`,
            height: `${25+windowWidth*0.01}vh`,
            backgroundImage: `url(${ornament2})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'right',
        },
        card: {
            backgroundColor: '#E1F9FF', 
            borderRadius: '7%', 
            padding: '5% 10% 10% 10%', 
            boxShadow: '0 3px 3px 0 rgba(0, 0, 0, 0.1)'
        },
        btnStyles: {
            borderRadius: 30,
            padding: '8px 15px',
            fontSize: '0.75rem',
            justifySelf: 'center',
            marginTop: '5%',
            width: '100%',
            backgroundColor: theme.palette.light.main,
            color: theme.palette.secondary.main,
        },
        txt:{
            header: {
                fontSize: `${250+windowWidth*0.06}%`,
                marginBottom: '2vh',
                textAlign: 'center',
                color: theme.palette.secondary.main
            },
            h5: {
                textAlign: 'center',
                fontSize: `${90+windowWidth*0.07}%`,
                fontWeight: 'bold',
                color: theme.palette.dark.main
            },
            larger: {
                textAlign: 'center',
                fontSize: `${80+windowWidth*0.07}%`,
                color: theme.palette.dark.main,
            },
            textAlign: 'center',
            fontSize: `${70+windowWidth*0.04}%`,
            color: theme.palette.dark.main,
            marginBottom: '2vh',
        },
        img: {
            width: '100%',
            marginBottom: '1vh',
        }
    }

    return (
        <>
        <Box sx={styles.box}>
            <div style={styles.bg2} />
            <div style={styles.bg1} />
            <h1 className="font-estetik" style={styles.txt.header}>Amplop Digital</h1>
            <p style={styles.txt}>Doa Restu Anda merupakan karunia yang sangat berarti bagi kami.<br/>Dan jika memberi adalah ungkapan tanda kasih Anda, Anda dapat memberi kado secara cashlesh melalui:</p>
            <br/>
            <Box data-aos='fade-up' data-aos-duration="1500" style={styles.card}>
                <img src={ornament} style={styles.img}/>
                <h5 style={styles.txt.h5}>{bank1}</h5>
                <p style={styles.txt.larger}>{rekening1}<br/>a.n. {atasNama1}</p>
                <Button variant="contained" onClick={() => handleButtonClick(rekening1)} style={styles.btnStyles}>
                    <ContentCopyIcon style={{ marginRight: '7px', fontSize: '1rem' }} />
                    Salin Rekening
                </Button>
            </Box>
            <Grid container spacing={4}>
                {/* <Grid data-aos='fade-right' data-aos-duration="1500" item xs={12} sm={6} style={{justifyContent: 'center'}}>
                    <Box style={{backgroundColor: '#f7fafc', borderRadius: '7%', padding: '5% 10% 10% 10%'}}>
                        <img src={ornament} style={styles.img}/>
                        <h5 style={styles.txt.h5}>{bank1}</h5>
                        <p style={styles.txt.larger}>{rekening1}<br/>a.n. {atasNama1}</p>
                        <Button variant="contained" onClick={() => handleButtonClick(rekening1)} style={styles.btnStyles}>
                            <ContentCopyIcon style={{ marginRight: '7px', fontSize: '1rem' }} />
                            Salin Rekening
                        </Button>
                    </Box>
                </Grid>
                <Grid data-aos='fade-left' data-aos-duration="1500" item xs={12} sm={6}>
                    <Box style={{backgroundColor: '#f7fafc', borderRadius: '7%', padding: '5% 10% 10% 10%'}}>
                        <img src={ornament} style={styles.img}/>
                        <h5 style={styles.txt.h5}>{bank2}</h5>
                        <p style={styles.txt.larger}>{rekening2}<br/>a.n. {atasNama2}</p>
                        <Button variant="contained" onClick={() => handleButtonClick(rekening2)} style={styles.btnStyles}>
                            <ContentCopyIcon style={{ marginRight: '7px', fontSize: '1rem' }} />
                            Salin Rekening
                        </Button>
                    </Box>
                </Grid> */}
                <Snackbar
                    open={open}
                    autoHideDuration={3000}
                    onClose={handleSnackbarClose}
                    TransitionComponent={Slide}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert severity={severity} variant="filled" onClose={handleSnackbarClose}>
                        <AlertTitle>{title}</AlertTitle>
                        {message}
                    </Alert>
                </Snackbar>
            </Grid>
            <div style={styles.ornament2} data-aos='fade-up' data-aos-duration="1500" />
            <div style={styles.ornament1} data-aos='fade-up' data-aos-duration="1500" />
            <br/>            
            <br/>
            <br/>            
            <br/>
            <br/>            
            <br/>
            <br/>            
            <br/>
        </Box>
        </>
    );
};

export default AmplopDigital;
